import { GradingPeriod } from '../../gradebook/v10/models/grading-period.model';

export class ClassroomSummary {

    Id: number;
    Meets: string;
    MeetsOrder: number;
    TermId: number;
    Term: string;
    TermTo: string;
    TermToDate = new Date();
    TermFrom: string;
    TermFromDate = new Date();
    Course: string;
    CourseHasProfile: boolean;
    CourseSection: string;
    Instructor: string;
    SubjectCode: string;
    Section: string;
    TodaysAttendance: number;
    TodaysGrading: number;
    Room: string;
    Enrolled: number;
    AttendanceRequired: boolean;
    MergedForAttendance: boolean;
    MergedForGrading: boolean;
    MergedAttendanceSection: boolean;
    MergedGradebookSection: boolean;
    MergedSectionName: string;
    MergedTGS_ID: number;
    MergedGradebookSSEC_ID: number;
    MergedAttendanceSSEC_ID: number;
    PeriodNumber: number;
    LunchIndicator: boolean;
    UpdatedDate = new Date();
    UsedForGrading: boolean;
    SubjectId: number;
    SiteSubjectListId: number;
    CourseSelected: boolean;
    TeacherId: number;
    PriorToStartofYear = new Date();
    BeyondEndofYear = new Date();
    SSEC_ID: number;
    StartDate = new Date();
    EndDate = new Date();
    IsCurrentCourse: boolean;
    GradebookMustAlignToObjective: boolean;
    DataBucket_ID: number;
    AdditionalTeacher: boolean;
    AdditionalTeacherSearchAttendance: boolean;
    AdditionalTeacherSubmitAttendance: boolean;
    AdditionalTeacherAccessGradebook: boolean;
    SeatingCharts: number;
    DefaultSeatingChart: string;
    GradeCycleId: number;
    GradePostedStatus: number;
    IsHomeRoom: boolean;
    MergedAttendancePrimarySubjectID: number;
    ProjectedStudent: number;
    GT_ID: number;
    GradingType: string;
    GBDisplayConfigExists: boolean;
    GBViewExists: boolean;
    RelatedTopic: number;
    ScoreStandardsByAssignment: boolean;
    HybridGradebook: boolean;
    ColumnsToExport: string[];
    GradebookAutoCalcObjScores: boolean;
    HasDefaultAttendanceCode: boolean;
    ObjectiveReportCardUsesSubjectGrades: boolean;
    ObjectiveReportCardUsesObjectiveGrades: boolean;
    AttendanceToday: boolean;
    GradeScaleExists: boolean;
    StandardsForReportCardsOnly: boolean;
    SectionNickName: string;
    GradebookAccess: boolean;
    GBCurrMarksNumericForStandards: boolean;
    StudentIds: number[] = [];
    ReportingSectionName: string; // THIS IS PURLEY THE SubjectSection.SSECName

    // Non DTO Fields
    Selected: boolean;
    Primary: boolean;
    CourseMenuText: string;
    courseSelected: boolean;
    IsSelectedForMassEmail: boolean;
    Students: any[];
    classStudentsCheckAll: boolean;
    copyChecked: boolean;
    copyPeriods: GradingPeriod[];
    selectedCopyPeriod: GradingPeriod;
    Merged: string;
}
